import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { useState, useContext } from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import Alert from '../Alert/Alert';
import Button from '../Button/Button';
import Link from '../Link/Link';
import PasswordField, { passwordValidationSchema } from '../PasswordField/PasswordField';
import TextField from '../TextField/TextField';
import useStyles from './RegisterForm.styles';
import { SiteContext, validateAllErrorsForSchema, commonValidationSchemas } from '../../utils/common';
import MarketingPreferencesToggle from './MarketingPreferencesToggle';
import PreferenceOptions from './PreferenceOptions';
export const validationSchema = Yup.object().shape({
    firstName: commonValidationSchemas.firstName,
    lastName: commonValidationSchemas.lastName,
    email: commonValidationSchemas.email,
    password: passwordValidationSchema,
});
export const initialValues = {
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    marketing: true,
    optInEmail: true,
    optInOnline: true,
    optInSms: true,
    optInPost: true,
};
const RegisterForm = (props) => {
    const { onSubmit, saveUserJourneyAnalytics } = props;
    const { isFlyingFlowers } = useContext(SiteContext);
    const { classes } = useStyles();
    const [errorMessage, setErrorMessage] = useState('');
    const [showOptions, setShowOptions] = useState(false);
    const handleRegistrationSubmission = (isSuccessful, email, error) => {
        setErrorMessage(error !== null && error !== void 0 ? error : '');
        saveUserJourneyAnalytics === null || saveUserJourneyAnalytics === void 0 ? void 0 : saveUserJourneyAnalytics({ journeyType: 'REGISTER', isSuccessful, email });
    };
    const formikConfig = {
        initialValues,
        validationSchema,
        validate: validateAllErrorsForSchema(Yup.object().shape({
            password: passwordValidationSchema,
        })),
        onSubmit: (values) => onSubmit(values)
            .then(() => {
            handleRegistrationSubmission(true, values === null || values === void 0 ? void 0 : values.email);
        })
            .catch((error) => {
            handleRegistrationSubmission(false, undefined, error.message);
        }),
    };
    return (_jsx(Formik, Object.assign({}, formikConfig, { children: ({ isSubmitting }) => (_jsx(Form, { children: _jsxs("div", { className: clsx(classes.container), children: [errorMessage && _jsx(Alert, { className: classes.error, type: "alertError", message: errorMessage }), _jsx("div", { className: classes.input, children: _jsx(TextField, { name: "firstName", label: "First name", placeholder: "e.g. John", fullWidth: true, required: true }) }), _jsx("div", { className: classes.input, children: _jsx(TextField, { name: "lastName", label: "Last name", placeholder: "e.g. Smith", fullWidth: true, required: true }) }), _jsx("div", { className: classes.input, children: _jsx(TextField, { name: "email", label: "Email address", placeholder: "e.g. john.smith@domain.co.uk", fullWidth: true, required: true }) }), _jsx("div", { className: classes.input, children: _jsx(PasswordField, { id: "password", name: "password", label: "Your password", placeholder: "e.g. YourPas5word", fullWidth: true, required: true, newPassword: true, signUp: true }) }), _jsx(MarketingPreferencesToggle, { isFlyingFlowers: isFlyingFlowers, setShowOptions: setShowOptions, showOptions: showOptions }), showOptions ? _jsx(PreferenceOptions, { isFlyingFlowers: isFlyingFlowers }) : null, _jsx("div", { className: classes.buttons, children: _jsx(Button, { variant: "secondaryDark", thin: true, fullWidth: true, title: isFlyingFlowers ? 'Create my account' : 'Create an account', icon: isFlyingFlowers ? 'sentiment_very_satisfied' : undefined, isSubmit: true, disabled: isSubmitting }) }), _jsxs("div", { className: classes.dataPolicy, children: [_jsx("h4", { children: "How we treat your data" }), _jsxs("p", { children: ["We will treat your personal information with respect and use it as detailed in our", ' ', _jsx(Link, { className: classes.link, label: "Privacy Policy", url: "/page/privacy" }), " and", ' ', _jsx(Link, { className: classes.link, label: "Cookie Policy", url: "/page/cookie-policy" }), "."] })] })] }) })) })));
};
export default RegisterForm;
